import { useSearchParamsContext } from '@internal/blocks/SearchResultsBlock/SearchParamsContext'
import { localeNamespace } from '@internal/utils/machine/i18n/Locale'
import { MachineType } from '@internal/utils/machine/MachineType'
import {
  BrandSelectFilter,
  TFilterOption,
} from '@renderer-ui-library/molecules'
import { useSearchResultsRouting } from 'blocks/SearchResultsBlock/useSearchResultsRouting'
import { translations } from 'i18n/translations'
import { useTranslation } from 'next-i18next'
import React, { useCallback, useMemo } from 'react'
import { tracker } from 'utils/tracking/tracker'
import { SearchFilterCategory } from './SearchFilterCategory/SearchFilterCategory'

type Props = {
  selectedMachineType: MachineType | null
}

export const BrandsFilter: React.FC<Props> = React.memo(
  ({ selectedMachineType }) => {
    const { searchParams } = useSearchParamsContext()
    const { gotoSearchResults } = useSearchResultsRouting()
    const { t } = useTranslation(localeNamespace.common)

    const handleBrandsSelectOnChange = useCallback(
      (newBrands: TFilterOption[] | null) => {
        const brands = newBrands?.map((brand) => brand.id) ?? []
        gotoSearchResults({
          ...searchParams,
          brands,
          amount: undefined,
        })

        tracker.trackEvent({
          name: 'filter-applied',
          filter_placement: 'serp',
          filter_category: 'brand',
          filter_brand: brands.join(','),
          is_interaction: true,
        })
      },
      [gotoSearchResults, searchParams]
    )

    const selectedBrands = useMemo(() => {
      return searchParams.brands.map<TFilterOption>((b) => ({
        id: b,
        label: b,
      }))
    }, [searchParams.brands])

    return (
      <SearchFilterCategory
        title={t(translations.searchResultsFiltersBrandsLabel)}
      >
        <BrandSelectFilter
          selectedMachineType={selectedMachineType}
          selectedBrands={selectedBrands}
          onChange={handleBrandsSelectOnChange}
          closeOnSelect
        />
      </SearchFilterCategory>
    )
  }
)

BrandsFilter.displayName = 'BrandsFilter'
